import type { TikTokPlayerEvent } from './useTikTokPlayerApi.types';

export const isTikTokMessage = (
  message: MessageEvent,
): message is MessageEvent<TikTokPlayerEvent> =>
  typeof message.data === 'object' && Boolean(message.data['x-tiktok-player']);
